/**
 * 问题数据API服务
 * 目前从本地JSON文件获取数据，未来可以替换为真实API
 */

// 获取所有问题数据
export async function fetchAllQuestions() {
  try {
    const response = await fetch('/data/questions.json');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching questions:', error);
    return { questions: [], categories: [] };
  }
}

// 获取指定ID的问题详情
export async function fetchQuestionById(id) {
  try {
    const response = await fetch('/data/questions.json');
    const data = await response.json();
    return data.questions.find(q => q.id == id) || null;
  } catch (error) {
    console.error('Error fetching question by id:', error);
    return null;
  }
}

// 获取所有分类
export async function fetchAllCategories() {
  try {
    const response = await fetch('/data/questions.json');
    const data = await response.json();
    return data.categories || [];
  } catch (error) {
    console.error('Error fetching categories:', error);
    return [];
  }
}

// 添加回答（目前只在前端内存中实现，未持久化）
export async function addAnswer(questionId, answer) {
  try {
    // 只在当前会话中添加回答，刷新页面后会丢失
    // 在真实环境中，这里应该发送POST请求到服务器
    console.log('Adding answer to question', questionId, answer);
    return {
      success: true,
      message: '回答已成功添加（注意：这只是前端模拟，刷新页面后会丢失）'
    };
  } catch (error) {
    console.error('Error adding answer:', error);
    return {
      success: false,
      message: '添加回答失败'
    };
  }
} 